enum MarketplaceAccessType {
  ALL = "all",
  DISABLED = "disabled",
  SELECTED = "selected",
}

export default MarketplaceAccessType;